'use client';

import React from 'react';

interface SizePickerProps {
  sizes: string[];
  selected: string | string[];
  onSelect: (size: string) => void;
  multi?: boolean;
  variant?: 'pills' | 'grid';
  className?: string;
}

export const SizePicker: React.FC<SizePickerProps> = ({
  sizes,
  selected,
  onSelect,
  multi = false,
  variant = 'pills',
  className,
}) => {
  const isSelected = (sz: string) =>
    multi ? (selected as string[]).includes(sz) : selected === sz;

  if (variant === 'pills') {
    return (
      <div className={`flex flex-wrap gap-1.5 ${className ?? ''}`}>
        {sizes.map(sz => (
          <button
            key={sz}
            type="button"
            onClick={() => onSelect(sz)}
            className={`text-[10px] font-bold px-2.5 py-0.5 rounded transition-all ${
              isSelected(sz)
                ? 'bg-blue-600 text-white font-extrabold border border-blue-500/30 shadow-md shadow-blue-500/10'
                : 'bg-slate-100 border border-slate-200 text-slate-600 hover:text-slate-950 hover:bg-slate-200/80'
            }`}
          >
            {sz}
          </button>
        ))}
      </div>
    );
  }

  return (
    <div className={className ?? 'grid grid-cols-4 gap-1 bg-slate-100 p-2 rounded-xl border border-slate-200/50'}>
      {sizes.map(sz => (
        <button
          key={sz}
          type="button"
          onClick={() => onSelect(sz)}
          className={`py-1 rounded text-[10px] font-bold transition-all ${
            isSelected(sz)
              ? 'bg-blue-600 text-white font-extrabold shadow-sm shadow-blue-500/10'
              : 'bg-white border border-slate-200 text-slate-600 hover:text-slate-950 hover:border-slate-350'
          }`}
        >
          {sz}
        </button>
      ))}
    </div>
  );
};
